import { render } from "./about-company.vue?vue&type=template&id=2cc94f51"
import script from "./about-company.vue?vue&type=script&lang=js"
export * from "./about-company.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__